import { useSelector } from "react-redux";
import UserRepository from "src/repository/Admin/UserRepository";
import { getUserDetail, getUserShippingDetail, getUserList, setUserList, getUserAcctList, getUserSearchAcctList, getSearchSponsorAccounts, setUserSearchAcctList, setUserSearchAcctPopupStatus, setRoleSelectionPopUpStatus, setSelectedRoles, setSelectedRoleIndex, setUserAcctList, setSelectedAccounts, setSelectedUserSponsorAccounts, setSearchSponsorAccounts } from "src/store/slice/model/Admin/User";
import store from "src/storeWire";


export function useUserStore() {
    const userList = useSelector((state) => state.entities.model_Admin.userList)
    const userCount = useSelector((state) => state.entities.model_Admin.userCount)
    const userDetail = useSelector((state) => state.entities.model_Admin.userDetail)
    const userShippingAddress = useSelector((state) => state.entities.model_Admin.userShippingAddress)
    const userAcctList = useSelector((state) => state.entities.model_Admin.userAcctList)
    const userSearchAcctList = useSelector((state) => state.entities.model_Admin.userSearchAcctList)
    const userSearchAcctPopupStatus = useSelector((state) => state.entities.model_Admin.userSearchAcctPopupStatus)
    const roleSelectionPopUpStatus = useSelector((state) => state.entities.model_Admin.roleSelectionPopUpStatus)
    const selectedRoles = useSelector((state) => state.entities.model_Admin.selectedRoles)
    const selectedRoleIndex = useSelector((state) => state.entities.model_Admin.selectedRoleIndex)
    const totalRecords = useSelector((state) => state.entities.model_Admin.totalRecords)
    const filteredRecords = useSelector((state) => state.entities.model_Admin.filteredRecords)
    const totalUserRecords = useSelector((state) => state.entities.model_Admin.totalUserRecords)
    const filteredUserRecords = useSelector((state) => state.entities.model_Admin.filteredUserRecords)
    const searchSponsorAccounts = useSelector((state) => state.entities.model_Admin.searchSponsorAccounts)
    const selectedAccounts = useSelector((state) => state.entities.model_Admin.selectedAccounts);
    const selectedUserSponsorAccounts = useSelector((state) => state.entities.model_Admin.selectedUserSponsorAccounts);

    let data = {
        userList,
        totalRecords,
        filteredRecords,
        userDetail,
        userShippingAddress,
        userAcctList,
        userSearchAcctList,
        userSearchAcctPopupStatus,
        roleSelectionPopUpStatus,
        selectedRoles,
        selectedRoleIndex,
        totalUserRecords,
        filteredUserRecords,
        searchSponsorAccounts,
        selectedAccounts,
        selectedUserSponsorAccounts,
    };

    let fetch = {
        get_user_list: async (params) => {
            return await store.dispatch(getUserList(params))
        },
        get_user_detail: async (userId) => {
            return await store.dispatch(getUserDetail(userId))
        },
        get_user_shipping_address_detail: async (userId) => {
            return await store.dispatch(getUserShippingDetail(userId))
        },
        get_user_acct_list: async (userId) => {
            return await store.dispatch(getUserAcctList(userId))
        },
        get_export_user_list: async () => {
            return await new UserRepository().exportUserList();
        },
        email_user_list: async (params) => {
            return await new UserRepository().emailUserList(params);
        },
        get_user_search_acct_list: async (params) => {
            return await store.dispatch(getUserSearchAcctList(params))
        },
        get_search_sponsor_accounts_list: async (params) => {
            return await store.dispatch(getSearchSponsorAccounts(params))
        },
    };
    let set = {
        delete_user: async (params) => {
            return await new UserRepository().deleteUsers(params);
        },
        add_user: async (params) => {
            return await new UserRepository().addUser(params);
        },
        update_user_acct_sponsorship: async (params) => {
            return await new UserRepository().updateUserAcctSponsorship(params);
        },
        update_unsponsor_user_acct: async (params) => {
            return await new UserRepository().updateUnsponsorUserAcct(params);
        },
        update_user_detail: async (params) => {
            return await new UserRepository().updateUserDetail(params);
        },
        update_user_shipping_address: async (params) => {
            return await new UserRepository().updateUserShippingAddress(params);
        },
        set_user_list: () => {
            return store.dispatch(setUserList([]));
        },
        set_search_acct_list: () => {
            return store.dispatch(setUserSearchAcctList([]));
        },
        set_user_search_acct_popup_status: (isOpen) => {
            return store.dispatch(setUserSearchAcctPopupStatus(isOpen));
        },
        set_role_selection_popup_status: (isOpen) => {
            return store.dispatch(setRoleSelectionPopUpStatus(isOpen));
        },
        set_selected_roles: (values) => {
            return store.dispatch(setSelectedRoles(values));
        },
        set_selected_role_index: (index) => {
            return store.dispatch(setSelectedRoleIndex(index));
        },
        set_user_acct_list: (data) => {
            return store.dispatch(setUserAcctList(data));
        },
        check_user_email: async (params) => {
            return await new UserRepository().checkUserEmail(params)
        },
        update_user_active_status: async (params) => {
            return await new UserRepository().updateUserActiveStatus(params)
        },
        set_selected_accounts: async (params) => {
            return store.dispatch(setSelectedAccounts(params));
        },
        set_select_user_sponsor_accounts: async (params) => {
            return store.dispatch(setSelectedUserSponsorAccounts(params));
        },
        set_search_sponsor_accounts_list: async (params) => {
            return store.dispatch(setSearchSponsorAccounts(params));
        },
        update_user_roles: async (params) => {
            return await new UserRepository().updateUserRoles(params)
        }
};
    return [data, fetch, set]
}